/**
 * Deployment features are capabilities switched on for a whole FOSSA deployment by its chart / config
 * (for example `llm:features:concludeLicenses:enabled`). They are distinct from feature flags
 * (`shared/featureFlags/flagNames.ts`), which are switched on per organization and stored in the
 * `FeatureFlags` table.
 *
 * The backend derives the enabled set from config (`modules/FeatureManager/deploymentFeatures.ts`) and
 * the HTML shell hydrates the same set onto `window.deploymentFeatures` for the frontend
 * (`app/helpers/features/deploymentFeatures.ts`). Both sides share these names.
 */
export enum DeploymentFeature {
  /** LLM-backed license conclusions. Requires both `llm:enabled` and `llm:features:concludeLicenses:enabled`. */
  LICENSE_CONCLUSIONS = 'licenseConclusions',
}

export type DeploymentFeatures = Record<DeploymentFeature, boolean>;
